import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';
import DropzoneInput from '../../../../components/Dropzone';

const DocumentData = ({ step, nextPage, prevPage, totalData, setTotalData, setShowRequestModal }) => {
  const { register, handleSubmit, errors } = useForm();
  const [filesCid, setFilesCid] = useState({ filesCidDir: '' });
  const [additional, setAdditional] = useState({ additional: '' });
  const [filesList, setFilesList] = useState([]);
  const translate = useIntl();

  const onSubmit = async () => {
    const filesCidDir = filesCid.filesCidDir && filesList.length ? filesCid.filesCidDir : '';
    const addInfo = additional.additional || '';

    const updStagesInfo = [...totalData.stagesInfo];
    const targetStageInfo = updStagesInfo.pop();
    targetStageInfo.filesCidDir = filesCidDir;
    targetStageInfo.additional = addInfo;
    updStagesInfo.push(targetStageInfo);
    setTotalData({ ...totalData, stagesInfo: updStagesInfo });

    nextPage();
  };

  const handleBadIpfs = () => {
    setShowRequestModal(true);
  };

  if (step !== 1) {
    return null;
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="upload-wizard__wrapper-form">
          <div className="upload-wizard__documents">
            <h3 className="upload-wizard__documents-label">
              {translate.formatMessage({ id: 'documentData.title' })}
            </h3>
            <div className="upload-wizard__documents-warning">
              <i className="icon-exclamation" />
              <span className="upload-wizard__documents-warning-text">
                {translate.formatMessage({ id: 'wizardForm.step3.projectDocumentation-warning' })}
              </span>
            </div>
            <DropzoneInput
              classCustom=""
              change={setFilesCid}
              multipleFiles
              amountFiles={10}
              droppedFiles={filesList}
              setDroppedFiles={setFilesList}
              acceptedFileTypes=".pdf, .txt, .doc, .jpeg, .jpg, .png"
              previewCustomClass="wizard__documents-item"
              handleBadIpfs={handleBadIpfs}
            />
          </div>
          <div className="upload-wizard__additional">
            <h3 className="upload-wizard__additional-label">
              {translate.formatMessage({ id: 'documentData.comments' })}
            </h3>
            <textarea
              className="upload-wizard__textarea"
              name="GenInfo"
              placeholder={translate.formatMessage({ id: 'documentData.comments' })}
              ref={register({ required: true })}
              onChange={(ev) => setAdditional({ additional: ev.target.value })}
              defaultValue={additional.additional}
            />
            {errors.GenInfo && <div className="input__error">{translate.formatMessage({ id: 'wizardForm.required' })}</div>}
          </div>
        </div>
        <div className="upload-wizard__panel upload-wizard__panel-document">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-back' })}
            handleClick={prevPage}
            type="button"
            customClass="btn__cancel"
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'button-save' })}
            handleClick={() => {}}
            type="submit"
            customClass="btn__btn-next"
          />
        </div>
      </form>
    </>
  );
};

export default DocumentData;
